var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Is available')},model:{value:(_vm.is_available),callback:function ($$v) {_vm.is_available=$$v},expression:"is_available"}})}
var staticRenderFns = []

export { render, staticRenderFns }